/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AffectedFleet } from './AffectedFleet';
import type { ApiVersion } from './ApiVersion';
import type { ListMeta } from '../../models/ListMeta';
/**
 * Blast radius for a single CVE across fleets and fleetless devices.
 */
export type VulnerabilityImpact = {
  apiVersion: ApiVersion;
  /**
   * Resource kind; always VulnerabilityImpact.
   */
  kind: string;
  metadata: ListMeta;
  /**
   * CVE identifier for this blast radius response.
   */
  cveId: string;
  /**
   * Name of the advisory issuer (e.g. Red Hat, NVD) when known.
   */
  issuer?: string;
  /**
   * URL to the CVE details page. Points to Red Hat Security portal for Red Hat advisories, otherwise to NVD.
   */
  link?: string;
  /**
   * Worst severity for this CVE in the fleet or fleetless group.
   */
  severity: VulnerabilityImpact.severity;
  /**
   * Highest CVSS base score for this CVE in the fleet or fleetless group.
   */
  maxCvssScore?: number;
  /**
   * When this CVE was first observed in the fleet or fleetless group.
   */
  maxPublishedAt?: string;
  /**
   * Per-fleet or fleetless rows with device and image counts.
   */
  items: Array<AffectedFleet>;
};
export namespace VulnerabilityImpact {
  /**
   * Worst severity for this CVE in the fleet or fleetless group.
   */
  export enum severity {
    CRITICAL = 'Critical',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
    NONE = 'None',
    UNKNOWN = 'Unknown',
  }
}

